import React, { useState } from "react";
import "./AuditoriumEvent.css";
import {
  SearchOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined
} from "@ant-design/icons";

import {
  Modal,
  Row,
  Col,
  TimePicker,
  Input,
  Button,
  Table,
  Carousel
} from "antd";

import { Booth } from "../../components/svgJS/Booth";
import { EyeView } from "../../components/svgJS/EyeView";

import { BoothRed } from "../../components/svgJS/BoothRed";
import { Chat } from "../../components/svgJS/Chat";
import { Video } from "../../components/svgJS/Video";
import { Download } from "../../components/svgJS/Download";
import { Bin } from "../../components/svgJS/Bin";

const AuditoriumEvent = () => {
  const [
    isAuditoriumEventModalVisible,
    setAuditoriumEventModalVisible
  ] = useState(false);

  const showAuditoriumEventModal = () => {
    setAuditoriumEventModalVisible(true);
  };

  const handleAuditoriumEventOk = () => {
    setAuditoriumEventModalVisible(false);
  };

  const handleAuditoriumEventModalCancel = () => {
    setAuditoriumEventModalVisible(false);
  };

  return (
    <>
      <Button
        className="ms-2"
        type="primary"
        onClick={showAuditoriumEventModal}
      >
        Open Auditorium Event Modal
      </Button>

      {/* Start of audtorium event Modal */}
      <Modal
        title=""
        visible={isAuditoriumEventModalVisible}
        onOk={handleAuditoriumEventOk}
        onCancel={handleAuditoriumEventModalCancel}
        className=""
        width={650}
        footer={null}
      >
        <div className=" w-100 p-4">
          <h6 className="opacity-75">Title :</h6>
          <h5>Speed Dating for Sales People</h5>
          <h6 className="opacity-75">Time :</h6>
          <p>14.10 - 15.10</p>
          <h6 className="opacity-75">Description :</h6>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <div className="d-flex mb-3">
            <Button className="audiEvent_downloadBtn">
              <Download />
              <span className="ms-2">Download iCal </span>
            </Button>
          </div>
          <h5>Speaker(s)</h5>
          <div className="d-flex p-3 border mx-4 mb-2">
            <img
              width={120}
              height={120}
              src="https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aHVtYW58ZW58MHx8MHx8&w=1000&q=80"
            />
            <div className="ms-3">
              <span className="opacity-75">Speaker</span>
              <h6>Alastair Reece</h6>
              <span>Bio</span>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt magna aliqua.
              </p>
            </div>
          </div>

          <div className="d-flex p-3 border mx-4 mb-2 mt-2">
            <img
              width={120}
              height={120}
              src="https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aHVtYW58ZW58MHx8MHx8&w=1000&q=80"
            />
            <div className="ms-3">
              <span className="opacity-75">Speaker</span>
              <h6>Alastair Reece</h6>
              <span>Bio</span>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt magna aliqua.
              </p>
            </div>
          </div>
          <h5>Brand</h5>
          <div className="d-flex p-3 border audiEvent_brand  mx-4">
            <img
              width={120}
              height={120}
              src="https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aHVtYW58ZW58MHx8MHx8&w=1000&q=80"
            />
            <div className="ms-3">
              <h6>Brand Name</h6>
              <p>Platinum</p>
              <BoothRed /> <span className="fs-pink">Visit Booth </span>
              <div className="d-flex mt-2">
                <div className="audiEvent_icons bg-white ms-2">
                  <Chat />
                </div>
                <div className="audiEvent_icons bg-white ms-2">
                  <Video />
                </div>
                <div className="audiEvent_icons bg-white ms-2">
                  <Video />
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex mt-4 mb-4">
            <div className="w-50"></div>
            <Button className="audiEvent_deleteBtn fs-16">
              <Bin /> <span className="ms-2">Delete Event</span>
            </Button>
            <Button className="audiEvent_joinBtn mx-4 fs-16">
              <BoothRed />
              <span className="ms-2">Join Session</span>
            </Button>
          </div>
        </div>
      </Modal>
      {/* End of  auditorium event mOdal */}
    </>
  );
};

export default AuditoriumEvent;
